import React, { useState } from 'react';
import Section from './Section';
import Button from './Button';
import { FixelsBadge } from './FixelsBranding';
import DemoModal from './DemoModal';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  return (
    <footer id="contact" className="bg-neutral-950 border-t border-white/10">
      <DemoModal 
        isOpen={demoModalOpen} 
        onClose={() => setDemoModalOpen(false)} 
        type="contact"
      />

      <Section className="py-20">
        <div className="flex flex-col items-center text-center mb-24">
          <h2 className="text-4xl md:text-6xl font-display text-white mb-6 tracking-tight">START A PROJECT</h2>
          <p className="text-neutral-400 max-w-lg mb-8 font-light leading-relaxed text-sm md:text-base">
            Wij werken uitsluitend op afspraak om de hoogste kwaliteit en discretie te waarborgen.
          </p>
          <Button onClick={() => setDemoModalOpen(true)} className="px-12 w-full md:w-auto">
            Neem Contact Op
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pt-12 border-t border-white/10">
          <div>
             <h3 className="text-white font-display mb-6 tracking-widest text-sm uppercase">Contact</h3>
             <ul className="space-y-2 text-neutral-400 text-sm font-light">
               <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer py-1" onClick={() => window.location.href = 'tel:+31201234567'}>
                 <Phone size={16} /> 
                 <span>+31 (0)20 123 4567</span>
               </li>
               <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer py-1" onClick={() => window.location.href = 'mailto:info@obsidian.nl'}>
                 <Mail size={16} /> 
                 <span>info@obsidian.nl</span>
               </li>
               <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer py-1">
                 <Instagram size={16} /> 
                 <span>@obsidian_auto</span>
               </li>
             </ul>
          </div>
          
          <div>
            <h3 className="text-white font-display mb-6 tracking-widest text-sm uppercase">Studio</h3>
            <ul className="space-y-2 text-neutral-400 text-sm font-light">
               <li className="flex items-start gap-3 py-1">
                 <MapPin size={16} className="mt-1 flex-shrink-0" /> 
                 <span>
                   Performance Drive 12<br/>
                   1010 AB, Amsterdam<br/>
                   Nederland
                 </span>
               </li>
             </ul>
          </div>

          <div>
             <h3 className="text-white font-display mb-6 tracking-widest text-sm uppercase">Openingstijden</h3>
             <ul className="space-y-3 text-neutral-400 text-sm font-light">
               <li className="flex justify-between max-w-[250px] border-b border-white/5 pb-2"><span>Ma - Vr</span> <span className="text-white">09:00 - 18:00</span></li>
               <li className="flex justify-between max-w-[250px] border-b border-white/5 pb-2"><span>Za</span> <span className="text-white">10:00 - 15:00</span></li>
               <li className="flex justify-between max-w-[250px] pb-2"><span>Zo</span> <span>Gesloten</span></li>
             </ul>
          </div>
        </div>
        
        <div className="mt-24 flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-white/5">
          <div className="text-center md:text-left text-neutral-700 text-[10px] uppercase tracking-[0.2em]">
            &copy; {new Date().getFullYear()} Obsidian Automotive. All rights reserved.
          </div>
          <FixelsBadge />
        </div>
      </Section>
    </footer>
  );
};

export default Footer;